module.exports = require('./workbook.js');